import React, { useEffect } from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import OneCardPreview from "components/appCard/OneCardPreview";
import { BasicAlert } from "components/Alert";
import { CopyToClipboard } from "react-copy-to-clipboard";

import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkIcon from "@material-ui/icons/Link";
import { initKakao, shareKakao } from "components/KakaoShare";

/* 파일 업로드 영역 */
const AppRunResult = ({ runApp, updateData, outputFiles, handleFileDownload, historyId, email, appName, oneLineContent }) => {
  useEffect(() => {}, [updateData]);

  const linkUrl = `https://aiso.ai/result?id=${historyId}&email=${email}`;

  useEffect(() => {
    initKakao();
  }, []);

  const handleKakaoShare = async () => {
    shareKakao(linkUrl, appName, oneLineContent);
  };

  return (
    <div className="w-full mt-2">
      <div className="w-full flex flex-col center">
        <div className="w-full sm:w-4/6 mt-2">
          {/* 실행 공간 */}
          <div className="w-full mt-3 flex flex-col justify-center text-center">
            {!runApp && outputFiles && outputFiles.length > 0 ? (
              <>
                {outputFiles.map((m, index) => (
                  <div className="w-full center mb-4" key={m}>
                    <OneCardPreview type={m.type} url={m.url} />
                    <div className="w-full py-2 px-3 bg-gray-input flex items-center justify-between">
                      {/* <p className="text-333">{`${inputFiles[0].file.name}`}</p> */}
                      <p className="text-333 mb-0">{`output_${index}`}</p>
                      <button
                        className="btn btn-white w-48 btn-sm mt-2 md:mt-0"
                        onClick={() => handleFileDownload(`output_${index}`, m.url, index)}
                      >
                        <GetAppIcon className="mr-2" /> 결과 다운로드
                      </button>
                    </div>
                  </div>
                ))}
                {historyId ? (
                  <div className="center mt-2">
                    <div className="popup-body flex flex-col justify-center items-center">
                      <h5 className="text-333 font-gmarket-medium text-2xl font-bold mb-4">Share</h5>
                      <div className="row w-full">
                        <div className="col-6 col-sm-3">
                          <div
                            className="share-card p-3"
                            onClick={() => {
                              window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl));
                            }}
                          >
                            <div className="face-share-icon">
                              <FacebookIcon fontSize="large" />
                            </div>
                            <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">facebook</p>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3">
                          <div className="share-card p-3" onClick={handleKakaoShare}>
                            <div className="kakao-share-icon">
                              <div style={{ width: "40px", height: "40px" }}>
                                <img className="p-1" src="/images/market/kakaotalk.svg" alt="" />
                              </div>
                            </div>
                            <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">Kakao Talk</p>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3">
                          <div
                            className="share-card p-3"
                            onClick={() => {
                              window.open("https://twitter.com/intent/tweet/?url=" + encodeURIComponent(linkUrl));
                            }}
                          >
                            <div className="twitter-share-icon">
                              <TwitterIcon fontSize="large" />
                            </div>
                            <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">Twitter</p>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3">
                          <CopyToClipboard
                            text={linkUrl}
                            onCopy={() => {
                              BasicAlert("공유 링크가 복사되었습니다.");
                            }}
                          >
                            <div className="share-card p-3">
                              <div className="twitter-share-icon">
                                <LinkIcon fontSize="large" />
                              </div>
                              <p className="mb-0 font-gmarket-medium text-xs text-888 mt-3">Copy Link</p>
                            </div>
                          </CopyToClipboard>
                        </div>
                      </div>
                    </div>
                    {/* <button
                      className="btn btn-primary text-xs font-bold px-3 py-2"
                      onClick={() => copyToClipboard(`https://aiso.ai/result?id=${historyId}&email=${email}`)}
                    >
                      <ShareIcon className="mr-2" /> 결과 공유하기
                    </button> */}
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppRunResult;
